import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

export const getPredictionCandidates = async (matchId) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  const params = new URLSearchParams();
  params.set('match_id', String(matchId));

  try {
    const res = await fetch(`${BASE_URL}/admin/arcade/prediction-candidates?${params.toString()}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    const data = await res.json().catch(() => ({}));
    return data;
  } catch {
    return { statusCode: '50000', message: 'Failed to load prediction candidates' };
  }
};

export const patchPredictionCandidates = async (payload) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const res = await fetch(`${BASE_URL}/admin/arcade/prediction-candidates`, {
      method: 'PATCH',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });
    const data = await res.json().catch(() => ({}));
    return data;
  } catch {
    return { statusCode: '50000', message: 'Failed to update prediction candidates' };
  }
};
